import React from 'react';
import Typography from '@/components/core/Typography/Typography';
import {
    CenteredFlex3XS,
    FormContainer,
    GreyTypography,
    PageTitle
} from '@/app/[locale]/(welcome)/_components';
import { useTranslations } from 'next-intl';
import { Flex2XS, FlexColXS, makeCentered } from '@/components/Flex';
import FormikTextInput from '@/components/core/formik/FormikTextInput';
import { Field, Form } from 'formik';
import styled from 'styled-components';
import Button from '@/components/core/Button';
import { Link } from '@/components/Link';
import GoogleAuth from '@/app/[locale]/(welcome)/auth/_components/GoogleAuth';
import capitalize from '@/utils/capitalize';
import { device } from '@/components/Media';

const StyledFormikTextInput = styled(FormikTextInput)`
    max-width: 420px;

    & > div > div {
        padding: 12px;
        height: 48px;
    }

    @media ${device.laptopS} {
        max-width: unset;
    }
`;

const StyledButton = styled(Button)`
    @media ${device.laptopS} {
        width: 100%;
        justify-content: center;
    }
`;

const StyledLink = styled(Link)`
    @media ${device.laptopS} {
        padding: 13.5px 12px;
    }
`;

const LoginWrapper = styled(CenteredFlex3XS)`
    @media screen and ${device.laptopS} {
        flex-direction: column;
        align-items: center;
        gap: ${({ theme }) => theme.spacing['2xs']};
    }
`;

const Separator = styled.div`
    content: ' ';
    height: 1px;
    width: 100%;
    background: ${({ theme }) => theme.colors.palette.grey_450};
`;

const MainContent = styled(FlexColXS)`
    flex-grow: 1;

    @media ${device.laptopS} {
        gap: ${({ theme }) => theme.spacing['2xs']};
    }
`;

const CenteredFlex2XS = makeCentered(Flex2XS, { y: true });

export function SignUpForm() {
    const t = useTranslations();

    return (
        <MainContent>
            <Form method='post'>
                <PageTitle>
                    {t.rich('auth.signUpTitle', {
                        br: () => <br />
                    })}
                </PageTitle>

                <FormContainer>
                    <Typography variant='uiType' size='md' modifier='S'>
                        {t('auth.signUpSubtitle')}
                    </Typography>

                    <Field
                      component={StyledFormikTextInput}
                      type='email'
                      name='email'
                      placeholder={t('auth.emailPlaceholder')}
                      autoComplete='email'
                    />

                    <StyledButton type='submit' variant='filled' size='lg' innerText={t('auth.signUp')} />
                </FormContainer>
            </Form>

            <LoginWrapper>
                <Typography variant='uiType' size='sm' modifier='R'>
                    {t('auth.alreadyHave')}
                </Typography>
                <StyledLink href='/auth/login' target='_self' variant='uiType' size='sm' modifier='S'>
                    {t('auth.logIn')}
                </StyledLink>
            </LoginWrapper>

            <CenteredFlex2XS>
                <Separator />

                <GreyTypography variant='uiType' size='md' modifier='R'>
                    {capitalize(t('common.or'))}
                </GreyTypography>

                <Separator />
            </CenteredFlex2XS>

            <GoogleAuth variant='SignUp' />
        </MainContent>
    );
}
